// https://assets1.lottiefiles.com/packages/lf20_jNZ8LE.json
export const micSpeakingLottieJson = {
        "v": "5.2.1", "fr": 30, "ip": 0, "op": 60, "w": 40, "h": 40, "nm": "Circle", "ddd": 0, "assets": [], "layers": [{
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Shape 2 Outlines",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [20.000000000000007, 20.000000000000007, 0], "ix": 2 },
                "a": { "a": 0, "k": [7, 9.5, 0], "ix": 1 },
                "s": { "a": 0, "k": [50.71428571428574, 50.71428571428574, 100], "ix": 6 },
            },
            "ao": 0,
            "ef": [{
                "ty": 5,
                "nm": "Position - Overshoot",
                "np": 3,
                "mn": "ADBE Slider Control",
                "ix": 1,
                "en": 1,
                "ef": [{
                    "ty": 0,
                    "nm": "Slider",
                    "mn": "ADBE Slider Control-0001",
                    "ix": 1,
                    "v": { "a": 0, "k": 20, "ix": 1, "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);" },
                }],
            }, {
                "ty": 5,
                "nm": "Position - Bounce",
                "np": 3,
                "mn": "ADBE Slider Control",
                "ix": 2,
                "en": 1,
                "ef": [{
                    "ty": 0,
                    "nm": "Slider",
                    "mn": "ADBE Slider Control-0001",
                    "ix": 1,
                    "v": { "a": 0, "k": 40, "ix": 1, "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);" },
                }],
            }, {
                "ty": 5,
                "nm": "Position - Friction",
                "np": 3,
                "mn": "ADBE Slider Control",
                "ix": 3,
                "en": 1,
                "ef": [{
                    "ty": 0,
                    "nm": "Slider",
                    "mn": "ADBE Slider Control-0001",
                    "ix": 1,
                    "v": { "a": 0, "k": 40, "ix": 1, "x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);" },
                }],
            }],
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.66, 0], [0, 1.66], [0, 0], [1.66, 0], [0, -1.66], [0, 0]],
                            "o": [[1.66, 0], [0, 0], [0, -1.66], [-1.66, 0], [0, 0], [0, 1.66]],
                            "v": [[0, 2.5], [2.99, -0.5], [3, -6.5], [0, -9.5], [-3, -6.5], [-3, -0.5]],
                            "c": true,
                        },
                        "ix": 2,
                    },
                    "nm": "Path 2",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false,
                }, {
                    "ind": 1,
                    "ty": "sh",
                    "ix": 2,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [2.76, 0], [0, 3], [0, 0], [-3.28, -0.49], [0, 0], [0, 0], [0, 0], [0, 3.42]],
                            "o": [[0, 3], [-2.76, 0], [0, 0], [0, 3.41], [0, 0], [0, 0], [0, 0], [3.28, -0.48], [0, 0]],
                            "v": [[5.3, -0.5], [0, 4.6], [-5.3, -0.5], [-7, -0.5], [-1, 6.22], [-1, 9.5], [1, 9.5], [1, 6.22], [7, -0.5]],
                            "c": true,
                        },
                        "ix": 2,
                    },
                    "nm": "Path 3",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false,
                }, { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false }, {
                    "ty": "fl",
                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                }, {
                    "ty": "tr",
                    "p": { "a": 0, "k": [7, 9.5], "ix": 2 },
                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                    "r": { "a": 0, "k": 0, "ix": 6 },
                    "o": { "a": 0, "k": 100, "ix": 7 },
                    "sk": { "a": 0, "k": 0, "ix": 4 },
                    "sa": { "a": 0, "k": 0, "ix": 5 },
                    "nm": "Transform",
                }],
                "nm": "Group 1",
                "np": 4,
                "cix": 2,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false,
            }],
            "ip": 0,
            "op": 171,
            "st": 0,
            "bm": 0,
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "base",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [20.000000000000007, 20.000000000000007, 0], "ix": 2 },
                "a": { "a": 0, "k": [11.178, -2.697, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [{
                        "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                        "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 0,
                        "s": [7.849285714285718, 7.849285714285718, 100],
                        "e": [8.849285714285719, 8.849285714285719, 100],
                    }, {
                        "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                        "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                        "n": ["0p667_1_0p333_0", "0p667_1_0p333_0", "0p667_1_0p333_0"],
                        "t": 30,
                        "s": [8.849285714285719, 8.849285714285719, 100],
                        "e": [7.849285714285718, 7.849285714285718, 100],
                    }, { "t": 60 }],
                    "ix": 6,
                },
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "d": 1,
                    "ty": "el",
                    "s": { "a": 0, "k": [331.855, 331.855], "ix": 2 },
                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                    "nm": "Ellipse Path 1",
                    "mn": "ADBE Vector Shape - Ellipse",
                    "hd": false,
                }, {
                    "ty": "st",
                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                    "o": { "a": 0, "k": 100, "ix": 4 },
                    "w": { "a": 0, "k": 0, "ix": 5 },
                    "lc": 1,
                    "lj": 1,
                    "ml": 4,
                    "ml2": { "a": 0, "k": 4, "ix": 8 },
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false,
                }, {
                    "ty": "fl",
                    "c": { "a": 0, "k": [0.27450980392156865, 0.6941176470588235, 0.2549019607843137, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                }, {
                    "ty": "tr",
                    "p": { "a": 0, "k": [11.178, -2.697], "ix": 2 },
                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                    "s": { "a": 0, "k": [75.704, 75.704], "ix": 3 },
                    "r": { "a": 0, "k": 0, "ix": 6 },
                    "o": { "a": 0, "k": 100, "ix": 7 },
                    "sk": { "a": 0, "k": 0, "ix": 4 },
                    "sa": { "a": 0, "k": 0, "ix": 5 },
                    "nm": "Transform",
                }],
                "nm": "Ellipse 1",
                "np": 3,
                "cix": 2,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false,
            }],
            "ip": 0,
            "op": 900.900900900901,
            "st": 0,
            "bm": 0,
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Base Layer 4",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "n": ["0p833_0p833_0p167_0p167"],
                        "t": 20.021,
                        "s": [49],
                        "e": [0],
                    }, { "t": 45.044921875 }],
                    "ix": 11,
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [20.000000000000007, 20.000000000000007, 0], "ix": 2 },
                "a": { "a": 0, "k": [11.178, -2.697, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [{
                        "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                        "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                        "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"],
                        "t": 0,
                        "s": [4.50457142857143, 4.50457142857143, 100],
                        "e": [9.909714285714289, 9.909714285714289, 100],
                    }, {
                        "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                        "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                        "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"],
                        "t": 20.021,
                        "s": [9.909714285714289, 9.909714285714289, 100],
                        "e": [12.126000000000005, 12.126000000000005, 100],
                    }, { "t": 45.044921875 }],
                    "ix": 6,
                },
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "d": 1,
                    "ty": "el",
                    "s": { "a": 0, "k": [331.855, 331.855], "ix": 2 },
                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                    "nm": "Ellipse Path 1",
                    "mn": "ADBE Vector Shape - Ellipse",
                    "hd": false,
                }, {
                    "ty": "st",
                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                    "o": { "a": 0, "k": 100, "ix": 4 },
                    "w": { "a": 0, "k": 0, "ix": 5 },
                    "lc": 1,
                    "lj": 1,
                    "ml": 4,
                    "ml2": { "a": 0, "k": 4, "ix": 8 },
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false,
                }, {
                    "ty": "fl",
                    "c": { "a": 0, "k": [0.6313725490196078, 0.9803921568627451, 0.615686274509804, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                }, {
                    "ty": "tr",
                    "p": { "a": 0, "k": [11.178, -2.697], "ix": 2 },
                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                    "s": { "a": 0, "k": [97.195, 97.195], "ix": 3 },
                    "r": { "a": 0, "k": 0, "ix": 6 },
                    "o": { "a": 0, "k": 100, "ix": 7 },
                    "sk": { "a": 0, "k": 0, "ix": 4 },
                    "sa": { "a": 0, "k": 0, "ix": 5 },
                    "nm": "Transform",
                }],
                "nm": "Ellipse 1",
                "np": 3,
                "cix": 2,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false,
            }],
            "ip": 0,
            "op": 900.900900900901,
            "st": 0,
            "bm": 0,
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Base Layer 3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "n": ["0p833_0p833_0p167_0p167"],
                        "t": 34.034,
                        "s": [27],
                        "e": [0],
                    }, { "t": 59.05859375 }],
                    "ix": 11,
                },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [20.000000000000007, 20.000000000000007, 0], "ix": 2 },
                "a": { "a": 0, "k": [11.178, -2.697, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [{
                        "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                        "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                        "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"],
                        "t": 14.014,
                        "s": [4.50457142857143, 4.50457142857143, 100],
                        "e": [9.909714285714289, 9.909714285714289, 100],
                    }, {
                        "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
                        "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
                        "n": ["0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167", "0p833_0p833_0p167_0p167"],
                        "t": 34.034,
                        "s": [9.909714285714289, 9.909714285714289, 100],
                        "e": [12.126000000000005, 12.126000000000005, 100],
                    }, { "t": 59.05859375 }],
                    "ix": 6,
                },
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "d": 1,
                    "ty": "el",
                    "s": { "a": 0, "k": [331.855, 331.855], "ix": 2 },
                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                    "nm": "Ellipse Path 1",
                    "mn": "ADBE Vector Shape - Ellipse",
                    "hd": false,
                }, {
                    "ty": "st",
                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                    "o": { "a": 0, "k": 100, "ix": 4 },
                    "w": { "a": 0, "k": 0, "ix": 5 },
                    "lc": 1,
                    "lj": 1,
                    "ml": 4,
                    "ml2": { "a": 0, "k": 4, "ix": 8 },
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false,
                }, {
                    "ty": "fl",
                    "c": { "a": 0, "k": [0.4627450980392157, 0.8666666666666667, 0.44313725490196076, 1], "ix": 4 },
                    "o": { "a": 0, "k": 100, "ix": 5 },
                    "r": 1,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false,
                }, {
                    "ty": "tr",
                    "p": { "a": 0, "k": [11.178, -2.697], "ix": 2 },
                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                    "s": { "a": 0, "k": [97.195, 97.195], "ix": 3 },
                    "r": { "a": 0, "k": 0, "ix": 6 },
                    "o": { "a": 0, "k": 100, "ix": 7 },
                    "sk": { "a": 0, "k": 0, "ix": 4 },
                    "sa": { "a": 0, "k": 0, "ix": 5 },
                    "nm": "Transform",
                }],
                "nm": "Ellipse 1",
                "np": 3,
                "cix": 2,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false,
            }],
            "ip": 0,
            "op": 900.900900900901,
            "st": 0,
            "bm": 0,
        }], "markers": [],
    }
;
